import { useState, useCallback, useEffect } from "react";

import {
  collection,
  getDoc,
  getDocs,
  query,
  orderBy,
  limit,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { getRef } from "lib/firebase";
import { convertDate } from "lib/utils";

import { CurrentUser, Notif } from "lib/type";

export const useHeader = (user: CurrentUser) => {
  const [side, setSide] = useState(false);
  const [notif, setNotif] = useState(false);
  const [search, setSearch] = useState(false);

  const changeMenu = (method: boolean, type: "side" | "notif" | "search") => {
    switch (type) {
      case "side":
        return setSide(method);
      case "notif":
        return setNotif(method);
      case "search":
        return setSearch(method);
      default:
        return;
    }
  };

  const openMenu = useCallback(
    (type: "side" | "notif" | "search") => changeMenu(true, type),
    []
  );

  const closeMenu = useCallback(
    (type: "side" | "notif" | "search") => changeMenu(false, type),
    []
  );

  const [unReadNotifCount, setUnReadNotifCount] = useState(0);
  useEffect(() => {
    if (!user) return;
    const unReadNotifRef = getRef(
      "users",
      `${user.uid}/unReadNotifs/${user.uid}`
    );
    const loadUnReadNotifCount = async () => {
      const unReadNotifDoc = await getDoc(unReadNotifRef).catch((err) => {
        console.log(err);
        alert("お知らせ未読数の取得に失敗しました。");
      });
      if (!unReadNotifDoc || !unReadNotifDoc.exists()) return;
      setUnReadNotifCount(unReadNotifDoc.data().count);
    };
    loadUnReadNotifCount();

    if (!notif) return;
    const readNotif = async () => {
      const unReadNotifDoc = await getDoc(unReadNotifRef).catch((err) => {
        console.log(err);
        alert("お知らせ既読状態の取得に失敗しました。");
      });
      if (!unReadNotifDoc || !unReadNotifDoc.exists()) return;
      await updateDoc(unReadNotifRef, {
        count: 0,
      }).catch((err) => {
        console.log(err);
        alert("お知らせの既読に失敗しました。");
      });
    };
    readNotif();
  }, [user, notif]);

  const [notifs, setNotifs] = useState<Notif[]>([]);
  useEffect(() => {
    if (!user) return;
    const loadNotifs = async () => {
      const userRef = getRef("users", user.uid);
      const q = query(
        collection(userRef, "notifs"),
        orderBy("createdAt", "desc"),
        limit(7)
      );
      const notifDocs = await getDocs(q).catch((err) => {
        console.log(err);
        alert("お知らせ一覧の取得に失敗しました。");
        return null;
      });
      if (!notifDocs || notifDocs.empty) return;
      const notifDatas = notifDocs.docs.map((doc) => {
        const notifData = doc.data();
        const {
          notifID,
          type,
          notifUid,
          articleID,
          userName,
          articleTitle,
          createdAt,
        } = notifData as {
          notifID: string;
          type: "like" | "comment" | "follow" | "announce";
          notifUid: string;
          articleID: string;
          userName: string;
          articleTitle: string;
          createdAt: Timestamp;
        };
        const createDate = convertDate(createdAt);
        return {
          notifID: notifID,
          type: type,
          notifUid: notifUid,
          articleID: articleID,
          userName: userName,
          articleTitle: articleTitle,
          createdAt: createDate,
        };
      });
      setNotifs(notifDatas);
    };
    loadNotifs();
  }, [user]);

  return {
    side,
    notif,
    search,
    openMenu,
    closeMenu,
    unReadNotifCount,
    notifs,
  };
};
